import PropTypes from 'prop-types';
import css from 'styled-jsx/css';
import classnames from 'classnames';

const listStyles = css`
  .list {
    padding-left: 16px;
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .list-item {
    list-style: none;
  }

  .list-item::before {
    display: inline-flex;
    margin-right: 10px;
    content: '';
    width: 8px;
    height: 9px;
    background: no-repeat url('/static/images/icons/bullet.svg');
  }
`;

const List = ({ items, className }) => {
  return items.length ? (
    <>
      <ul className={classnames('list', className)}>
        {items.map(item => (
          <li className="list-item" key={item.key}>
            {item.text}
          </li>
        ))}
      </ul>
      <style jsx>{listStyles}</style>
    </>
  ) : null;
};

List.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string
};

export default List;
